module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-page"
    }
  }, [_c('div', {
    staticClass: "page animsition vertical-align text-center sign-in-wrapper",
    attrs: {
      "data-animsition-in": "fade-in",
      "data-animsition-out": "fade-out"
    }
  }, [_c('div', {
    staticClass: "page-content form-max-width vertical-align-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-page-title"
  }, [_vm._v("\n                Sign In to Trackado\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "login-form"
  }, [(_vm.showLoginSection) ? _c('div', {
    staticClass: "login-page-description"
  }, [_vm._v("Please enter your credentials to sign in.")]) : _c('div', {
    staticClass: "verify-desc-text"
  }, [_vm._v("\n                    Enter the 6-digit code we sent to the phone number ending **" + _vm._s(_vm.user.phoneNumber) + ". "), _c('br'), _vm._v("\n                    Didn't receive a code?\n                    "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#54C08A"
    },
    on: {
      "click": function($event) {
        return _vm.goBackToLoginSection(true)
      }
    }
  }, [_vm._v("Start over to resend.")])]), _vm._v(" "), (_vm.isFaliedInvalidCredentials) ? _c('div', {
    staticClass: "login-fail-msg"
  }, [_vm._v("\n                    Wrong username or password, please try again.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isFaliedLockedCompany) ? _c('div', {
    staticClass: "login-fail-msg"
  }, [_vm._v("\n                    Your account is locked. Please contact us at"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@trackado.com?Subject=My trackado account is locked",
      "target": "_top"
    }
  }, [_vm._v("support@trackado.com")]), _vm._v(" to get help.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isFaliedLockedUser) ? _c('div', {
    staticClass: "login-fail-msg"
  }, [_vm._v("\n                    Your account has been locked for security reasons since we detected multiple failed sign-in attempts. Please reach out to your administrator or to our support.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isFaliedEnforceSso) ? _c('div', {
    staticClass: "login-fail-msg"
  }, [_vm._v("\n                    Your account requires SSO authentication. Please use the "), _c('a', {
    attrs: {
      "href": 'Sso/Login'
    }
  }, [_vm._v("SSO sign-in")]), _vm._v(" instead\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isTwoFactorVerificationLimitExceeded) ? _c('div', {
    staticClass: "login-fail-msg"
  }, [_vm._v("\n                    You have reached the maximum amount of verification requests per day and cannot send any more requests for security reasons. Please contact our support if you think that this is an error or that your account has been breached!\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isFalied2FA) ? _c('div', {
    staticClass: "login-fail-msg"
  }, [_vm._v("\n                    Wrong 2FA verification code, please try again.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.showLoginSection) ? _c('div', [_c('form', {
    attrs: {
      "id": "frm-login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignInClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-material floating inp-error-marker"
  }, [_c('v-input-text', {
    attrs: {
      "type": _vm.text,
      "label": 'EMAIL',
      "placeholder": 'Email',
      "value": _vm.user.email,
      "required": true,
      "showError": _vm.validation.forEmail,
      "errorMessage": 'Please insert email.'
    },
    on: {
      "input": function (val) { return (_vm.user.email = val); },
      "focus": function($event) {
        _vm.validation.forEmail = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material floating inp-error-marker"
  }, [_c('v-input-text', {
    attrs: {
      "type": 'Password',
      "label": 'PASSWORD',
      "placeholder": 'Password',
      "value": _vm.user.password,
      "required": true,
      "showError": _vm.validation.forPassword,
      "errorMessage": 'Please insert password.'
    },
    on: {
      "input": function (val) { return (_vm.user.password = val); },
      "focus": function($event) {
        _vm.validation.forPassword = false
      }
    }
  })], 1), _vm._v(" "), (!_vm.twoFAModal.isOpen) ? _c('div', {
    attrs: {
      "id": "friendly-captcha"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSignInClicked) ? _c('button', {
    staticClass: "btn btn-success btn-block login-btn",
    attrs: {
      "type": "submit",
      "id": "submit-login-btn",
      "disabled": _vm.isSubmitBtnDisabled
    }
  }, [_vm._v("SIGN IN")]) : _c('button', {
    staticClass: "btn btn-success btn-block login-btn",
    attrs: {
      "type": "button",
      "id": "submit-login-btn-loader",
      "hidden": ""
    }
  }, [_c('img', {
    staticClass: "loader-icon-gif",
    attrs: {
      "src": '/Assets/loader.gif'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-default pull-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.rememberMe),
      expression: "user.rememberMe"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.rememberMe) ? _vm._i(_vm.user.rememberMe, null) > -1 : (_vm.user.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "rememberMe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "rememberMe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "rememberMe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Remember me")])]), _vm._v(" "), _c('a', {
    staticClass: "pull-right forgot-password",
    attrs: {
      "href": 'Account/ForgotPassword'
    }
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix social-login"
  }, [_c('a', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "href": 'Sso/Google'
    }
  }, [_c('img', {
    attrs: {
      "src": '/Assets/icons/login.with.google.png'
    }
  }), _vm._v("\n                                Sign in with Google\n                            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default pull-right sign-with-social",
    attrs: {
      "href": 'Sso/Live'
    }
  }, [_c('img', {
    attrs: {
      "src": '/Assets/icons/login.with.microsoft.png'
    }
  }), _vm._v("\n                                Sign in with Microsoft\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix sso-login"
  }, [_c('a', {
    staticClass: "sign-with-sso",
    attrs: {
      "href": 'Sso/Login'
    }
  }, [_vm._v("\n                                Sign in with SSO\n                            ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "login-page sign-up"
  }, [_vm._v("\n                                Don't have an account? "), _c('a', {
    attrs: {
      "href": 'Account/Registration'
    }
  }, [_vm._v("Sign Up")])])])])]) : _c('div', [_c('form', {
    attrs: {
      "id": "frm-verify"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onVerifyClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('code-input', {
    staticClass: "input",
    attrs: {
      "loading": false,
      "type": _vm.number
    },
    on: {
      "complete": function (value) { return _vm.user.code = value; }
    }
  }), _vm._v(" "), (_vm.isVerifyValid) ? _c('label', {
    staticClass: "error-text"
  }, [_vm._v("Please insert one digit in all of the fields.")]) : _vm._e()], 1), _vm._v(" "), (!_vm.isVerifyClicked) ? _c('button', {
    staticClass: "btn btn-success btn-block login-btn verify-sign-in",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SIGN IN")]) : _c('button', {
    staticClass: "btn btn-success btn-block login-btn verify-sign-in",
    attrs: {
      "type": "button",
      "hidden": ""
    }
  }, [_c('img', {
    staticClass: "loader-icon-gif",
    attrs: {
      "src": '/Assets/loader.gif'
    }
  })]), _vm._v(" "), (_vm.showCheckboxFor30days) ? _c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-default pull-left verify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberTwoFactorAuthentication),
      expression: "rememberTwoFactorAuthentication"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberTwoFactorAuthentication) ? _vm._i(_vm.rememberTwoFactorAuthentication, null) > -1 : (_vm.rememberTwoFactorAuthentication)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberTwoFactorAuthentication,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberTwoFactorAuthentication = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberTwoFactorAuthentication = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberTwoFactorAuthentication = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Don't ask me again on this computer for 30 days.")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_vm._v("Having trouble? "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "4px"
    },
    on: {
      "click": function($event) {
        _vm.backupCodeModal.isOpen = true
      }
    }
  }, [_vm._v("Use a backup code.")])])])])]), _vm._v(" "), (_vm.showLoginSection) ? _c('div', {
    staticClass: "friendly-captcha-login-div"
  }, [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _c('v-modal', {
    attrs: {
      "show": _vm.backupCodeModal.isOpen,
      "headerVisible": true,
      "size": 'md'
    },
    on: {
      "close": function($event) {
        _vm.backupCodeModal.isOpen = false
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "col-xs-12",
          staticStyle: {
            "margin-top": "30px",
            "display": "flex",
            "text-align": "center",
            "margin-left": "58px",
            "margin-bottom": "10px"
          }
        }, [_c('div', {
          staticClass: "site-menu-icon events-menu-icon section-icon"
        }, [_c('i', {
          staticClass: "icon-administer",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), _c('h4', {
          staticClass: "contract-section-title",
          staticStyle: {
            "color": "#575b67",
            "font-size": "32px",
            "margin-top": "0px"
          }
        }, [_vm._v("Enter back-up verification code")])])]
      },
      proxy: true
    }, {
      key: "body",
      fn: function() {
        return [_c('div', {
          staticClass: "modal-content-wrapper"
        }, [_c('div', {
          staticClass: "form-group form-material floating inp-error-marker",
          staticStyle: {
            "width": "300px",
            "margin-right": "auto",
            "margin-left": "auto"
          }
        }, [_c('v-input-text', {
          attrs: {
            "type": _vm.text,
            "label": 'BACK-UP CODE',
            "placeholder": 'Back-up code',
            "value": _vm.user.backupCode,
            "required": true,
            "showError": _vm.isBackUpCodeValid,
            "errorMessage": 'Please insert back-up code.'
          },
          on: {
            "input": function (val) { return (_vm.user.backupCode = val); },
            "focus": function($event) {
              _vm.isBackUpCodeValid = false
            }
          }
        })], 1)])]
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(!_vm.isBackupCodeVerifyClicked) ? _c('button', {
          staticClass: "btn btn-success btn-block login-btn backup-sign-in",
          attrs: {
            "type": "submit"
          },
          on: {
            "click": _vm.singInWithBackupCode
          }
        }, [_vm._v("SIGN IN")]) : _c('button', {
          staticClass: "btn btn-success btn-block login-btn backup-sign-in",
          attrs: {
            "type": "button",
            "hidden": ""
          }
        }, [_c('img', {
          staticClass: "loader-icon-gif",
          attrs: {
            "src": '/Assets/loader.gif'
          }
        })])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-modal', {
    attrs: {
      "show": _vm.twoFAModal.isOpen,
      "headerVisible": true,
      "size": 'md'
    },
    on: {
      "close": _vm.closeTwoFactorAuthModal
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "col-xs-12",
          staticStyle: {
            "margin-bottom": "8px"
          }
        }, [_c('div', {
          staticClass: "title-icon-wrap"
        }, [_c('div', {
          staticClass: "site-menu-icon events-menu-icon modal-title-icon modals-icon custom-icon-title"
        }, [_c('i', {
          staticClass: "icon-maintain-categories",
          attrs: {
            "aria-hidden": "true"
          }
        })])]), _vm._v(" "), (_vm.verifyPhoneNumber) ? _c('div', {
          staticClass: "title-text-wap"
        }, [_c('span', {
          staticClass: "2fa-modal-title modals-title custom-text-title"
        }, [_vm._v("Verify Your Mobile Number")])]) : _c('div', {
          staticClass: "title-text-wap"
        }, [_c('span', {
          staticClass: "2fa-modal-title modals-title custom-text-title"
        }, [_vm._v("Enable Two-Factor Authentication")])])])]
      },
      proxy: true
    }, {
      key: "body",
      fn: function() {
        return [_c('form', {
          staticClass: "model-body-mobile-number"
        }, [(_vm.verifyPhoneNumber) ? _c('div', {
          staticClass: "verify-mobile-num-modal"
        }, [_c('div', {
          staticClass: "desc-text",
          staticStyle: {
            "align-items": "center",
            "text-align": "center",
            "padding-top": "20px"
          }
        }, [_vm._v("\n                        Enter the 6-digit code we sent to " + _vm._s(_vm.internationalMobileNumberFormat) + " "), _c('br'), _vm._v("\n                        Didn't receive a code?\n                        "), _c('a', {
          staticStyle: {
            "cursor": "pointer",
            "color": "#54C08A"
          },
          on: {
            "click": _vm.submitMobileNumber
          }
        }, [_vm._v("Resend.")])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('code-input', {
          staticClass: "input",
          attrs: {
            "loading": false,
            "type": _vm.number
          },
          on: {
            "complete": function (value) { return _vm.verificationCode = value; }
          }
        }), _vm._v(" "), (_vm.isVerifyValid) ? _c('label', {
          staticClass: "error-text"
        }, [_vm._v("Please insert one digit in all of the fields.")]) : _vm._e()], 1)]) : _c('div', {
          staticClass: "add-mobile-num-modal"
        }, [_c('div', {
          staticClass: "desc-text"
        }, [_vm._v("\n                        Your account administrator has configured mandatory two-factor authentication for all users. Please update your phone number and we will text a verification code to this mobile device whenever you sign in to your account.\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-xs-12 form-group form-material inp-error-marker mobile-number-select margin16"
        }, [_c('v-phone-number-input', {
          ref: "mobileNumber",
          attrs: {
            "value": _vm.userPhoneNumber,
            "required": true,
            "defaultCountryCode": _vm.userCountryCode,
            "showError": _vm.twoFAModalValidation.forPhoneNumber || _vm.isMobileFormatValid,
            "errorMessage": _vm.isMobileFormatValid ? 'Incorrect format.' : 'Please insert a mobile number.'
          },
          on: {
            "input": _vm.onChangePhoneNumber,
            "update": _vm.updatePhoneNumber,
            "focus": _vm.focusOnNewMobileInput
          }
        })], 1)]), _vm._v(" "), _c('div', {
          staticClass: "desc-text"
        }, [_vm._v("\n                        By providing your mobile number, you agree to receive text messages from Trackado.\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "tfa-captcha",
          attrs: {
            "id": "friendly-captcha"
          }
        })])])]
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(_vm.verifyPhoneNumber) ? _c('button', {
          staticClass: "btn btn-base btn-editable btn-success confirm-btn",
          attrs: {
            "id": "verify-mobile-number-btn",
            "type": "button"
          },
          on: {
            "click": _vm.verifySMScode
          }
        }, [_c('span', {
          staticClass: "icon-save modal-btn-icon-old",
          staticStyle: {
            "padding-right": "6px"
          }
        }), _vm._v("CONFIRM\n                ")]) : _c('button', {
          staticClass: "btn btn-base btn-editable btn-success confirm-btn",
          attrs: {
            "id": "submit-new-field-btn",
            "type": "button"
          },
          on: {
            "click": _vm.submitMobileNumber
          }
        }, [_c('span', {
          staticClass: "icon-save modal-btn-icon-old",
          staticStyle: {
            "padding-right": "8px"
          }
        }), _vm._v("CONFIRM PHONE NUMBER\n                ")])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-modal', {
    staticClass: "back-up-codes-modal",
    attrs: {
      "show": _vm.backupCodesModal.isOpen,
      "headerVisible": true,
      "size": 'md'
    },
    on: {
      "close": function($event) {
        _vm.backupCodesModal.isOpen = false
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "title-icon-wrap"
        }, [_c('div', {
          staticClass: "site-menu-icon events-menu-icon modal-title-icon modals-icon custom-icon-title"
        }, [_c('i', {
          staticClass: "icon-administer",
          attrs: {
            "aria-hidden": "true"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "title-text-wap",
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_c('span', {
          staticClass: "modals-title custom-text-title"
        }, [_vm._v("Back-up verification codes")])])]
      },
      proxy: true
    }, {
      key: "body",
      fn: function() {
        return [_c('div', {
          staticClass: "modal-content-wrapper"
        }, [_c('p', {
          staticClass: "text-information"
        }, [_vm._v("Back-up codes can be used in case you no longer have access to your mobile phone.")]), _vm._v(" "), _c('p', {
          staticClass: "text-information"
        }, [_vm._v("Each code can be used once. We recommend you store them in a safe place.")]), _vm._v(" "), _c('div', {
          staticClass: "codes-section"
        }, [_vm._l((_vm.backupCodesPairs), function(pair, index) {
          return _c('div', {
            key: 'bc-' + index,
            staticClass: "row code-pairs"
          }, [_c('div', {
            staticClass: "col-sm-6 left-side"
          }, [_c('span', {
            class: {
              'isUsed': pair.left.IsUsed
            }
          }, [_vm._v(_vm._s(pair.left.Code))])]), _vm._v(" "), (pair.right) ? _c('div', {
            staticClass: "col-sm-6 right-side"
          }, [_c('span', {
            class: {
              'isUsed': pair.right.IsUsed
            }
          }, [_vm._v(_vm._s(pair.right.Code))])]) : _vm._e()])
        }), _vm._v(" "), _c('p', {
          staticClass: "copy-codes",
          on: {
            "click": _vm.copyCodesToClipboard
          }
        }, [_vm._v("Copy codes to the clipboard.")])], 2), _vm._v(" "), _c('textarea', {
          attrs: {
            "id": "area-codes"
          }
        }, [_vm._v(_vm._s(_vm.formattedCodes))])]), _vm._v(" "), _c('div', {
          staticClass: "checkbox-custom checkbox-success",
          staticStyle: {
            "margin": "25px 37px -15px"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.backupCodesModal.isCodesSaved),
            expression: "backupCodesModal.isCodesSaved"
          }],
          staticClass: "event-reminder-enable-cbx",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.backupCodesModal.isCodesSaved) ? _vm._i(_vm.backupCodesModal.isCodesSaved, null) > -1 : (_vm.backupCodesModal.isCodesSaved)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.backupCodesModal.isCodesSaved,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(_vm.backupCodesModal, "isCodesSaved", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(_vm.backupCodesModal, "isCodesSaved", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(_vm.backupCodesModal, "isCodesSaved", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "cbx-label"
        }, [_vm._v("\n                    I have saved my codes.\n                    "), _c('span', {
          staticClass: "requred-input-indicator"
        }, [_vm._v("*")])])])]
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-base btn-success btn-editable",
          staticStyle: {
            "margin-top": "6px"
          },
          attrs: {
            "type": "submit",
            "disabled": !_vm.backupCodesModal.isCodesSaved
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.activate2FA.apply(null, arguments)
            }
          }
        }, [_c('span', {
          staticClass: "icon-save modal-btn-icon-old",
          staticStyle: {
            "margin-right": "6px",
            "margin-left": "-15px"
          }
        }), _vm._v("ACTIVATE 2FA\n                ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-base btn-editable btn-edit",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.backupCodesModal.isOpen = false
            }
          }
        }, [_c('span', {
          staticClass: "icon-cancel modal-btn-icon-old",
          staticStyle: {
            "margin-right": "6px",
            "margin-left": "-15px"
          }
        }), _vm._v("CANCEL\n                ")])])]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('a', {
    attrs: {
      "href": "http://www.trackado.com"
    }
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "Assets/landing/logo-landing.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "side-lines"
  }, [_c('span', [_vm._v("OR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "friendly-captcha-login-p"
  }, [_vm._v("This site is protected by "), _c('a', {
    attrs: {
      "href": "https://friendlycaptcha.com/",
      "target": "_blank"
    }
  }, [_vm._v("Friendly Captcha")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3a53f9bb!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./modules/login-page/LoginPage.vue
// module id = 2765
// module chunks = 18